export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'ekylikeio',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '0.0.10'
};